var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"tooltip-container",class:['tooltip-container', 
  {
  medium: _vm.size === 'medium',
  large: _vm.size === 'large',
  center: _vm.position === 'center',
  tr: _vm.position === 'tr',
  right: _vm.position === 'right',
  bc: _vm.position === 'bc'
  }
]},[_c('div',{staticClass:"connecter-part"}),_c('div',{staticClass:"tooltip"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }